import { Pipe, PipeTransform } from '@angular/core';
import { Entity, UnallocatedUserId } from '@jms/model';

@Pipe({
    name: 'unAllocated',
    standalone: false
})
export class UnAllocatedPipe implements PipeTransform {

  transform(entity: Entity): boolean {
    return entity?._id === UnallocatedUserId;
  }

}
